var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1124 0.252197C20.4761 0.252197 17.567 3.16129 17.567 6.79765C17.567 10.434 20.4761 13.3431 24.1124 13.3431C27.7488 13.3431 30.6579 10.434 30.6579 6.79765C30.6579 3.16129 27.7488 0.252197 24.1124 0.252197ZM24.1124 11.1613C21.6979 11.1613 19.7488 9.2122 19.7488 6.79765C19.7488 5.98311 19.967 5.22674 20.3597 4.61583L26.2943 10.5504C25.6833 10.9431 24.927 11.1613 24.1124 11.1613ZM27.8652 8.97947L21.9306 3.04493C22.5415 2.6522 23.2979 2.43402 24.1124 2.43402C26.527 2.43402 28.4761 4.38311 28.4761 6.79765C28.4761 7.6122 28.2579 8.36856 27.8652 8.97947Z",
    fill: "#266C87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2895 28.8869H3.71052V5.308H13.8158V1.93958H3.71052C1.85789 1.93958 0.342102 3.45536 0.342102 5.308V28.8869C0.342102 30.7396 1.85789 32.2554 3.71052 32.2554H27.2895C29.1421 32.2554 30.6579 30.7396 30.6579 28.8869V18.7817H27.2895V28.8869ZM20.5526 18.7817V25.5185H23.921V18.7817H20.5526ZM13.8158 25.5185H17.1842V12.0448H13.8158V25.5185ZM10.4474 25.5185V15.4133H7.07894V25.5185H10.4474Z",
    fill: "#266C87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartErrorIcon);
export default __webpack_public_path__ + "static/media/chart-error-icon.9bea01a374370428d69e63f1f06a5bbb.svg";
export { ForwardRef as ReactComponent };